import * as $ from "jquery";
import imkt from '../../../../imkt';
import tracking from '../../../../utils/tracking';

imkt.wac.Aws = class Aws {
  $domRoot: HTMLElement;
  params: {};
  awsButtons: JQuery<HTMLElement>; 

  constructor(domRoot: HTMLElement, params: Object) {
    this.$domRoot = domRoot || $("body");
    this.params = { ...params };

    this.awsButtons = $(".aws-quick-start", this.$domRoot);

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.awsButtons.on("click", function () {
      // @ts-ignore
      tracking.trackEvent("AWS Quick Start", eventProperties);
    });
  }
}

new imkt.wac.Aws();
